import { KeyFieldsFunction } from '@apollo/client/cache/inmemory/policies';
import { StoreObject } from '@apollo/client/utilities';

export const getPropertyKey: KeyFieldsFunction = (
    object: Readonly<StoreObject>
) => {
    if (object['uprn']) {
        return ['uprn'];
    }
    if (object['propertyId']) {
        return ['propertyId'];
    }
    return false;
};
